import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { ApiService } from './api.service';
import { SessionStatus } from 'src/app/constants/session';
import { StoreNames } from 'src/app/constants/storage-names';
import { SessionService } from './storage/session.service';
import { EnrollmentBenefitCategory } from '../models/enrollment-category';
import { EnrollmentCategoryOptionManager } from '../models/enrollment-option';
import { ContentHeaderCriteria, ContentHeaderModel } from '../models/content-header';
import { BenefitRequests } from '../models/benefit-requests';

const controllerRoute = '/enrollment-dashboard';
const controllerRouteEnrollment = '/enrollment';

@Injectable()
export class EnrollmentDashboardService {
    //public selectedEnrollmentBenefitCategoryId: number;
    public sessionStore: Observable<any>;

    constructor(
        private apiService: ApiService,
        private sessionService: SessionService,
    ) {
        this.sessionStore = this.sessionService.$SessionClear;
        this.sessionStore.subscribe((status: string) => {
            switch (status) {
                case SessionStatus.initalize:
                    // let sessionState = this.sessionService.retrieve(StoreNames.selectedEnrollmentBenefitCategoryId);
                    // if (sessionState)
                    //     this.selectedEnrollmentBenefitCategoryId = sessionState;
                    break;

                case SessionStatus.clearMember:
                    // this.selectedEnrollmentBenefitCategoryId = null;
                    // this.sessionService.remove(StoreNames.selectedEnrollmentBenefitCategoryId);
                    break;

                case SessionStatus.clearSession:
                    // this.selectedEnrollmentBenefitCategoryId = null;
                    break;
            }
        });
    }

    public getEnrollmentCategoires(): Observable<EnrollmentBenefitCategory> {
        return this.apiService.get(`${controllerRoute}/company-categories`).pipe(
            map((response: EnrollmentBenefitCategory) => {
                return response;
            }),
        );
    }

    public getHeaderContent(payload: ContentHeaderCriteria): Observable<any> {
        return this.apiService.post(`${controllerRoute}/content-header`, payload).pipe(
            map((response: ContentHeaderModel) => {
                return response;
            }),
        );
    };

    public getBenefitChangeRequests(): Observable<BenefitRequests> {
        return this.apiService.get(`${controllerRouteEnrollment}/benefit-requests/avaliable-options`).pipe(
            map((response: BenefitRequests) => {
                return response;
            }),
        );
    }
}